import axios, { AxiosResponse } from "axios";
import moment from "moment";
import Qs from "qs";

import { ApplicationRoute } from "../routes";
import { expireApiToken, getApiToken, getLanguage } from "../store/auth/side_effects";

export const httpClient = axios.create({
  baseURL: "/api/",
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
  paramsSerializer: (params: Record<string | number, any>) => {
    const validParams = Object.keys(params).reduce((result, paramName) => {
      const paramValue = params[paramName];
      return {
        ...result,
        [paramName]: moment.isMoment(paramValue) ? (paramValue as moment.Moment).format("YYYY-MM-DD") : paramValue,
      };
    }, {});
    return Qs.stringify(validParams, { arrayFormat: "repeat", encode: false });
  },
  validateStatus: (status) => status >= 200 && status < 400,
});

export const externalHTTPClient = axios.create({
  baseURL: "",
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

httpClient.interceptors.request.use(
  async (config) => {
    const cfg = config;

    const token = getApiToken();
    if (token) {
      cfg.headers.Authorization = `Token ${token}`;
    }

    const language = getLanguage();
    if (language) {
      cfg.headers["Accept-Language"] = language;
    }

    return cfg;
  },
  (error) => {
    Promise.reject(error);
  }
);

httpClient.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    if (error.response === undefined) {
      return null;
    }
    if (error.response.status === 401 && window.location.pathname !== ApplicationRoute.Login) {
      expireApiToken();
      const next = window.location.pathname + (window.location.search !== "" ? `?${window.location.search}` : "");
      window.location.href = `${ApplicationRoute.Login}?${Qs.stringify({ next })}`;
    }
    return Promise.reject(error);
  }
);

export const callPost = (url: string, data?: unknown, params?: any): Promise<AxiosResponse> => {
  return httpClient.post(url, data, { params });
};

export const callGet = (url: string, params?: any, cancelToken?: any): Promise<AxiosResponse> => {
  return httpClient.get(url, { cancelToken, params });
};

export const callDelete = (url: string, params?: any): Promise<AxiosResponse> => {
  return httpClient.delete(url, { params });
};

export const externalCallGet = (url: string, params?: unknown): Promise<AxiosResponse> => {
  return externalHTTPClient.get(url, { params, baseURL: "" });
};
